import { IonButton, IonFab, IonIcon, IonText } from "@ionic/react";
import { addOutline } from "ionicons/icons";
import { useParams } from "react-router";
import { UserTemplateListContainer } from "./UserTemplateListContainer";


export const TemplatesSection = () => {
    const { id }: { id: string } = useParams();

    return (
        <>
            <h2 className="ion-padding-horizontal">
                <IonText color="primary">Formularios</IonText>
            </h2>

            <section className="ion-padding-horizontal">
                <UserTemplateListContainer />
            </section>

            <IonFab vertical="bottom" horizontal="end" slot="fixed">
                <IonButton routerLink={`/app/rrhh/usuarios/acuerdos/${id}`} size="default" color="secondary">
                    <IonIcon icon={addOutline} slot="start"></IonIcon>
                    <IonText>Asociar plantilla</IonText>
                </IonButton>
            </IonFab>

        </>
    );

}
